module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QwECi8j5rLUGAAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAA3klEQVRYw2NgGAVDDaw+W/F/9dmK/9Qyj4UUi2nhISZKQoIaDmCk1KJQ4w7GAQkBaoUETgdM2R+iRKzh6Or+//8vg00cWwLG6QBxPpW75IYEIyPjE2Idz0StYEVOC8j6V5+t+P/w7bkAoh1AjuUhRu3a+PSferBqPVEOIDdBMTIyXiMlip59uC6H4QByLccV9CTlgoGynCrlAFXqAvTSDJtvYGqwyZHqeykBzUeDKwSoWeRiCyl8oTfgIcBESoqntOajKAooiSp80Tf8EuGgKYiITTNDJxcMWweMglEAAP0mgMSMuFL8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_bi_sin.png
// module id = xLT4
// module chunks = 0